var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Nav'),_c('v-main',{staticStyle:{"background-color":"#f0f2f5"}},[_c('router-view')],1),_c('Footer'),_c('QRCodeDialog'),_c('Dish'),_c('OrderDialog'),_c('BottomCartSheet')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }